import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './styles/global.css';
import './styles/common/variables.css';

const origError = console.error;

console.error = function (...args) {
  const msg = args[0];

  // 过滤掉特定的 Recharts 警告
  if (typeof msg === 'string' && msg.includes('The width(0) and height(0)')) {
    return; // 直接忽略
  }

  // 默认情况正常输出
  origError.apply(console, args);
};
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
